import { render, staticRenderFns } from "./TopupConfirm.vue?vue&type=template&id=34359bf4&scoped=true"
import script from "./TopupConfirm.vue?vue&type=script&lang=js"
export * from "./TopupConfirm.vue?vue&type=script&lang=js"
import style0 from "./TopupConfirm.vue?vue&type=style&index=0&id=34359bf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34359bf4",
  null
  
)

export default component.exports